import React from 'react';
import { Box, Typography } from '@mui/material';

interface RateCalculationDisplayProps {
    grouperCode: string;
    weight: number;
    baseRate: number;
    calculatedRate: number;
}

export const RateCalculationDisplay: React.FC<RateCalculationDisplayProps> = ({
    grouperCode,
    weight,
    baseRate,
    calculatedRate
}) => {
    if (!grouperCode || weight <= 0) return null;

    return (
        <Box sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1, border: '1px solid', borderColor: 'grey.200' }}>
            <Typography variant="subtitle2" gutterBottom>
                Rate Calculation
            </Typography>
            <Typography variant="body2" color="text.secondary">
                Base Rate × Weight = Calculated Rate
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace', mt: 1 }}>
                ${baseRate.toLocaleString('en-US', { minimumFractionDigits: 2 })} × {weight.toFixed(4)} = <strong>${calculatedRate.toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
            </Typography>
        </Box>
    );
};
